import { graphql } from "@opensea/graphql"
import { useCreateCalendarEventFragment } from "@/components/collection/drops/use-create-calendar-event.fragment"

export const AddToCalendarOptionsFragment = graphql(
  `
  fragment AddToCalendarOptions on Drop {
    stages {
      stageIndex
      ...useCreateCalendarEvent
    }
  }
`,
  [useCreateCalendarEventFragment],
)
